<script type="text/javascript">

	import Textfield from "@smui/textfield";
	import HelperText from "@smui/textfield/helper-text/index";
	import { writable } from "svelte/store";
	import LocalStorageHelper from "../../Helpers/LocalStorageHelper";
	import MenuItem from "../FlyoutMenu/MenuItem.svelte";
	import ModalWindow from "../ModalWindow.svelte";
	import NotepadStore from "./Store";
	
	let visible = NotepadStore.meta.visible;

	let notes = writable("");
	notes.set(LocalStorageHelper.get("notes", ""));
	notes.subscribe((val) => {
		LocalStorageHelper.set("notes", val);
	});

</script>


<ModalWindow
	title={`Notepad`}
	hasCloseButton={true}
	hasBackground={false}
	resizable={true}
	draggable={true}
	fullscreen={false}
	padding={false}
	position="top-right"
	height="70%"
	bind:open={$visible} >

	<MenuItem title={"Notes"} materialIcon={"notes"}>

		<!-- <Textfield dense variant="filled" bind:value={$notes} label="" style="width:100%" /> -->
		<Textfield textarea bind:value={$notes} input$aria-controls="helper-text-textarea" input$aria-describedby="helper-text-textarea" style="width:100%" />
		<HelperText id="helper-text-textarea">Notes are just for you, and they save automagically!</HelperText>

	</MenuItem>

</ModalWindow>

